import type { AssetColors } from '../../palette.js';

const OAKS = [
  {
    crown:
      'M-5.7,-6.1 C-7.8,-6.5 -7.8,-9.4 -5.7,-9.8 C-6.4,-12 -4.6,-13.4 -2.8,-12.8 C-2.3,-15.2 .3,-15.7 1.7,-13.9 C3.5,-14.9 5.5,-13.6 5.2,-11.8 C7.9,-11.6 8,-8.8 6.2,-7.9 C6.7,-5.6 4,-4.5 2.3,-5.5 C.8,-3.9 -1.4,-4.7 -2,-5.3 Q-4,-4.1 -5.7,-6.1Z',
    face: 'M-5.7,-6.1 C-7.8,-6.5 -7.8,-9.4 -5.7,-9.8 C-6.4,-12 -4.6,-13.4 -2.8,-12.8 C-2.3,-15.2 .3,-15.7 1.7,-13.9 C3.5,-14.9 5.5,-13.6 5.2,-11.8 Q3.8,-9.8 2.1,-10.8 Q2,-7.8 -.6,-8.4 Q-2.2,-5.3 -3.7,-6.6Z',
    light:
      'M-5.6,-9.9 Q-6,-12 -3.8,-12.2 L-3.1,-11.3 Q-2.1,-11.7 -1.7,-10.7 Q-3.9,-11 -5.6,-9.9Z M-2.5,-12.9 Q-1.7,-14.9 .2,-14.5 L1,-13.5 Q-.9,-13.8 -2.5,-12.9Z',
    trunk:
      'M-3,.65 -1.3,-.6 -1,-3.4 -3.6,-6.6 -2.9,-7 -.4,-4.9 -.65,-8.1 .4,-8.5 .75,-5.3 3.2,-7.7 3.8,-7.1 1.2,-3.7 1.35,-.6 3.3,.5 1.2,.6 .2,.1 -1,.8Z',
    bark: 'M-1.2,.1 -.5,-1.1 -.5,-3.6 -1.7,-5.9 -.8,-5.1 .2,-3.3 .05,-1.1 .7,.35Z',
    hollow: 'M.25,-2.4 Q-.4,-3.8 .35,-4.4 Q1.05,-3.8 .7,-2.6Z',
  },
  {
    crown:
      'M-3.9,-6.2 C-6.3,-7.5 -5.9,-10 -4.1,-10.8 C-5.1,-13 -3.8,-15 -2,-14.8 C-1.8,-17.9 .8,-18.3 2,-16.5 C4.4,-16.7 5.4,-14.8 4.5,-13 C6.1,-11.5 5.5,-9.5 3.8,-9.1 C4.1,-6.5 1.9,-5.5 .4,-6.7 Q-1.7,-4.7 -3.9,-6.2Z',
    face: 'M-3.9,-6.2 C-6.3,-7.5 -5.9,-10 -4.1,-10.8 C-5.1,-13 -3.8,-15 -2,-14.8 C-1.8,-17.9 .8,-18.3 2,-16.5 Q3.5,-15.1 1.7,-13.5 Q3.4,-11.2 1.5,-10 Q1.6,-7.7 -.3,-8 Q-1.8,-6 -3.9,-6.2Z',
    light:
      'M-3.9,-11.2 Q-4.5,-13.5 -2.4,-14 L-1.6,-13 Q-3.3,-13 -3.9,-11.2Z M-1.7,-15 Q-1.6,-17.6 .5,-17.2 L1.1,-16.2 Q-.7,-16.6 -1.7,-15Z',
    trunk:
      'M-2.7,.5 -1.5,-1.1 -1.7,-3.5 -3.1,-6.8 -2.3,-7.2 -.6,-4.5 .1,-7.6 1,-7.6 .6,-4 2.9,-6.6 3.5,-6.1 1.2,-2.8 1.3,-.8 2.6,.7 .5,.4 -.8,.8Z',
    bark: 'M-1.7,-.1 -1,-1.2 -1.2,-3.6 -2.2,-5.6 -1.4,-4.9 -.2,-2.9 -.25,-.2Z',
    hollow: 'M-.65,-.8 Q-1.2,-2.8 -.25,-3.7 Q.8,-2.6 .35,-.8Z',
  },
  {
    crown:
      'M-6.5,-8 C-7.6,-9.8 -5.9,-11.6 -4.4,-11.1 C-4.7,-13.1 -2.5,-14.3 -.9,-13.4 C.6,-15.2 2.8,-14.6 3.4,-13.1 C5.7,-13.6 7.4,-12.1 6.7,-10.4 C8,-8.7 6.4,-7 4.9,-7.2 C3.8,-5.5 1.9,-6.3 1.3,-7.1 Q-1,-5.6 -2.1,-7.1 Q-4.9,-6.3 -6.5,-8Z',
    face: 'M-6.5,-8 C-7.6,-9.8 -5.9,-11.6 -4.4,-11.1 C-4.7,-13.1 -2.5,-14.3 -.9,-13.4 C.6,-15.2 2.8,-14.6 3.4,-13.1 Q4.8,-13.3 5.3,-12 Q4,-10 2.5,-10.8 Q1.2,-8.5 -.3,-9.4 Q-2.5,-7.1 -3.3,-8.4Z',
    light:
      'M-4.2,-11.3 Q-4.1,-13 -2.6,-13 L-1.5,-12.1 Q-3.3,-12.4 -4.2,-11.3Z M-.7,-13.5 Q.8,-14.7 2.2,-13.7 L2.7,-12.8 Q.6,-13.3 -.7,-13.5Z',
    trunk:
      'M-4,.5 Q-.5,-1.6 -.6,-4.2 L-3.4,-8.1 -2.4,-8.5 .4,-5.5 1.5,-8.6 2.4,-8.4 1.2,-4.7 4.4,-7.5 5,-7 1.4,-3.2 Q.5,-1.1 1.1,.35 L2,.75 -.3,.65 -1.1,0 -2.5,.6Z',
    bark: 'M-3,.25 Q.2,-1.5 -.3,-4.3 L-1.5,-6.8 -.6,-5.7 .7,-3.6 Q.8,-1.4 -.8,-.1Z',
    hollow: 'M.15,-3.5 Q.4,-4.6 1.1,-4.7 L.7,-3.6Z',
  },
] as const;

export function svgAncientOak(x: number, y: number, c: AssetColors, v: number): string {
  const tree = OAKS[v] ?? OAKS[0];
  return (
    `<g transform="translate(${x},${y})">` +
    `<ellipse cx=".4" cy=".5" rx="4.8" ry=".9" fill="${c.shadow}" opacity=".15"/>` +
    `<path d="${tree.trunk}" fill="${c.trunk}"/><path d="${tree.bark}" fill="${c.stump}"/>` +
    `<path d="${tree.hollow}" fill="${c.shadow}"/>` +
    `<path d="${tree.crown}" fill="${c.bushDark}"/><path d="${tree.face}" fill="${c.leaf}"/>` +
    `<path d="${tree.light}" fill="${c.leafLight}"/>` +
    `<path d="M-3.5,.4 -4.4,-.4 -3.6,-.2 -3.6,-1.4 -3.1,-.5 -2.1,-.9 -2.6,.1Z M1.8,.7 1.3,-.1 2.2,.15 2.9,-.6 3,.25 3.9,.1 3.6,.6Z" fill="${c.moss}"/>` +
    `<path d="M-2.9,-7.3a.28,.4 0 1 0 .56,0a.28,.4 0 1 0 -.56,0 M3.1,-8.3a.26,.36 0 1 0 .52,0a.26,.36 0 1 0 -.52,0" fill="${c.acornBody}"/></g>`
  );
}
